import * as Mod1 from "./discourse/components/d-templates/filterable-list";
import * as Mod2 from "./discourse/components/d-templates/item-content";
import * as Mod3 from "./discourse/components/d-templates/item";
import * as Mod4 from "./discourse/components/d-templates/modal/form";
import * as Mod5 from "./discourse/components/d-templates/tag-drop";
import * as Mod6 from "./discourse/connectors/below-footer/d-templates-modal-container.gjs";
import * as Mod7 from "./discourse/connectors/editor-preview/d-templates.gjs";
import * as Mod8 from "./discourse/connectors/topic-above-posts/discourse-templates-button.gjs";
import * as Mod9 from "./discourse/initializers/d-templates";
import * as Mod10 from "./discourse/initializers/templates-admin-plugin-configuration-nav";
import * as Mod11 from "./discourse/services/d-templates-modal";
import * as Mod12 from "./discourse/services/d-templates";
import * as Mod13 from "./lib/replace-variables";
import * as Mod14 from "./lib/variables-chat-channel";
import * as Mod15 from "./lib/variables-chat-thread";
import * as Mod16 from "./lib/variables-composer";
const compatModules = {
  "discourse/components/d-templates/filterable-list": Mod1,
  "discourse/components/d-templates/item-content": Mod2,
  "discourse/components/d-templates/item": Mod3,
  "discourse/components/d-templates/modal/form": Mod4,
  "discourse/components/d-templates/tag-drop": Mod5,
  "discourse/connectors/below-footer/d-templates-modal-container": Mod6,
  "discourse/connectors/editor-preview/d-templates": Mod7,
  "discourse/connectors/topic-above-posts/discourse-templates-button": Mod8,
  "discourse/initializers/d-templates": Mod9,
  "discourse/initializers/templates-admin-plugin-configuration-nav": Mod10,
  "discourse/services/d-templates-modal": Mod11,
  "discourse/services/d-templates": Mod12,
  "lib/replace-variables": Mod13,
  "lib/variables-chat-channel": Mod14,
  "lib/variables-chat-thread": Mod15,
  "lib/variables-composer": Mod16,
};
export { compatModules };
export default compatModules;
